import ImageAsset from "@simplebooth/webkit/build/library/common/ImageAsset"
import headerStyles from "./BrandedHeader.module.scss"
import animations from "../../styles/Animations.module.scss"
import {MARKETING_WEBSITE_URL} from "../../library/globals"

interface BrandedHeaderProps {
  showDefaultLogo?: boolean | null
  imageAsset?: ImageAsset | null
  imageHref?: string | null
  imageMaxWidth?: number // 0-100
  heading?: string
  description?: string
  textColor?: string
}

export default function BrandedHeader({
                                        showDefaultLogo,
                                        imageAsset,
                                        imageHref,
                                        heading,
                                        description,
                                        textColor,
                                        imageMaxWidth,
                                      }: BrandedHeaderProps) {
  let headerImage = <></>
  if (showDefaultLogo) {
    headerImage =
      <a
        href={MARKETING_WEBSITE_URL}
        target="_blank"
        rel="noopener"
      >
        <img
          className={`${headerStyles.defaultLogo} ${animations.hoverScale}`}
          src={`${process.env.PUBLIC_URL}/simple-booth-logo.svg`}
          alt="Simple Booth Logo"
          style={{
            maxWidth: "160px"
          }}
        />
      </a>
  }

  if (imageAsset) {
    headerImage = (
      <img
        src={imageAsset.url}
        alt="Gallery Branding"
        loading="eager"
        style={{
          maxWidth: imageMaxWidth ?? 100 + "%",
          maxHeight: "360px",
        }}
      />
    )

    if (imageHref) {
      headerImage = (
        <a
          href={imageHref}
          target="_blank"
          rel="noopener"
        >
          {headerImage}
        </a>
      )
    }
  }

  let textStyles = textColor ? {color: textColor} : {}

  return (
    <header className={headerStyles.header}>
      {headerImage}
      {heading &&
          <h1
              className={headerStyles.heading}
              style={{...textStyles,
                marginTop: "30px",
                fontWeight: 600,
                wordWrap: "break-word",
          }}>
            {heading}
          </h1>
      }
      {description &&
          <div
              style={{
                ...textStyles,
                fontWeight: 500,
                fontSize: "18px",
                maxWidth: "640px",
                margin: "15px auto 0 auto",
              }}>
            {description}
          </div>
      }
    </header>
  )
}
